import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'db-loading-dotted-circle',
    templateUrl: './loading-dotted-circle.component.html',
    imports: [CommonModule],
    styleUrls: ['./loading-dotted-circle.component.scss'],
    host: {
        '[class.s]': 'size === "s"',
        '[class.m]': 'size === "m"',
        '[class.l]': 'size === "l"'
    }
})
export class LoadingDottedCircleComponent implements OnInit, OnChanges {
  @Input() width: string = '18';
  @Input() size: 's' | 'm' | 'l' = 'm';
  @Input() height: string = '18';
  @Input() percent: number = 0;
  @Input() whiteColored?: boolean = false;
  readonly totalDots = 8;
  readonly radius = 6;
  readonly dotSize = 2.33;
  public fullDots: number;
  public dots;


  ngOnInit() {
    this._createDots();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['percent'] && changes['percent'].previousValue) {
      this._createDots();
    }
  }

  private _createDots(): void {
    this.fullDots = Math.floor((this.percent / 100) * this.totalDots);
    this.dots = Array.from({ length: this.totalDots }, (_, i) => {
      const angle = (2 * Math.PI * i) / this.totalDots;
      return {
        x: this.radius * Math.cos(angle),
        y: this.radius * Math.sin(angle),
        opacity: i < this.fullDots ? 1 : 0.5
      };
    });
  }
}
